import { useTranslation } from "react-i18next";
import { LanguageSelection } from "../LanguageSelection/LanguageSelection";
import { NavigationLink } from "../NavigationLink/NavigationLink";
import { PageSelection } from "../PageSelection/PageSelection";
import { SolutionPageSelection } from "../SolutionPageSelection/SolutionPageSelection";
import { ResourcePageSelection } from "../ResourcePageSelection/ResourcePageSelection";
import { DemoTrialModalButton } from "../ModalButtons/DemoTrialModalButton";
import { RetailersButton } from "../RetailersButton/RetailersButton";
import { NavbarSearchButton } from "../Search/NavbarSearchButton";
import { getImage } from "../../services/ImageService";

export function Navbar() {
    const { t } = useTranslation();

    return (
        <nav
            aria-label="Main navigation"
            className="flex font-roboto bg-white text-pine h-32 fixed w-full z-50 2xl:justify-center"
        >
            <div className="h-full flex relative w-full justify-start px-12 lg:px-24 2xl:px-60 lg:justify-between max-w-[180rem] mx-auto">
                <PageSelection />
                <div className="hidden h-full 2xl:flex items-center gap-6">
                    <NavigationLink
                        className="!h-[50px] !w-[50px]"
                        content={
                            <div className="bg-pine hover:!bg-[#313D38] rounded-full h-full w-full flex justify-center items-center">
                                <img
                                    src={getImage("logos/gf-icon-white.svg")}
                                    alt="Global Forester"
                                    className="h-12 select-none"
                                ></img>
                            </div>
                        }
                        target=""
                    />
                    <SolutionPageSelection />
                    <ResourcePageSelection />
                    <NavbarSearchButton />
                </div>
                <div className="bg-white h-full z-20 flex items-center lg:gap-6">
                    <LanguageSelection />
                    <DemoTrialModalButton className="hidden my-6 lg:flex" />
                    <RetailersButton className="hidden my-6 lg:flex" />
                </div>
            </div>
        </nav>
    );
}
